export default defineNuxtPlugin({
  name: "authorization-resolver",
  parallel: true,
  setup() {
    return {
      provide: {
        authorization: {
          resolveClientUser: async () => {
            const user = useCurrentUser();
         

            if (!user?.value?.uid) return null;
            const userData = useState(`userData-${user?.value?.uid}`);
         
            return userData.value || null;
          },
        },
      },
    };
  },
});
